export const neutral = {
  25: "#f9fafb",
  50: "#f2f4f7",
  100: "#f2f4f7",
  200: "#eaecf0",
  300: "#d0d5dd",
  400: "#98a2b3",
  500: "#667085",
  600: "#475467",
  700: "#344054",
  800: "#1D2939",
  900: "#101828",
};

export const primary = {
  25: "#f5f8ff",
  50: "#eff4ff",
  100: "#d1e0ff",
  200: "#b2ccff",
  300: "#84adff",
  400: "#528bff",
  500: "#2970dd",
  600: "#155eef",
  700: "#004eeb",
  800: "#0040c1",
  900: "#00359e",
};

export const success = {
  25: "#f6fef9",
  50: "#ecfdf3",
  100: "#d1fadf",
  200: "#a6f4c5",
  300: "#6ce9a6",
  400: "#32d583",
  500: "#12b76a",
  600: "#039855",
  700: "#027a48",
  800: "#05603a",
  900: "#054f31",
};

export const info = {
  25: "#fafeff",
  50: "#f0fcff",
  100: "#c6fffa",
  200: "#91fefe",
  300: "#5ff2fe",
  400: "#3cdffd",
  500: "#13c1fc",
  600: "#0d92d3",
  700: "#086bab",
  800: "#044b85",
  900: "#044b85",
};

export const warning = {
  25: "#fffcf5",
  50: "#fffaeb",
  100: "#fef0c7",
  200: "#fedf89",
  300: "#fec84b",
  400: "#fdb022",
  500: "#f79009",
  600: "#dc6803",
  700: "#b54708",
  800: "#93370d",
  900: "#7a2e0e",
};

export const danger = {
  25: "#fffbfa",
  50: "#fef3f2",
  100: "#fee4e2",
  200: "#fecdca",
  300: "#fda29b",
  400: "#f97066",
  500: "#f04438",
  600: "#d92d20",
  700: "#b42318",
  800: "#912018",
  900: "#7a271a",
};
